<!-- This component wraps Fuse Alert and allows to control the mode via AlertDisplayService. -->
<ng-container *ngIf="shouldShowAlert">
    <fuse-alert class="manusa-alert rounded-2xl bg-white shadow-lg" #alert
                [dismissible]="dismissible"
                [dismissed]="dismissed"
                [appearance]="appearance"
                [name]="name"
                [type]="type">
        {{ message | transloco }}
    </fuse-alert>
</ng-container>
